import { ReactNode } from 'react';
import { QuoteExits } from 'clients/types';
import { TeamInsuranceProduct } from 'types';
import { FilterElementProps, SearchInputProps } from 'utils';
import { ProductFilterAttributes } from './useProductFilter';

export type SelectedTeamProductsMap = Record<string, TeamInsuranceProduct>;

export interface ProductsProps {
  selectedProducts: SelectedTeamProductsMap;
  onProductSelected: (product: TeamInsuranceProduct) => void;
  onProductRemoved: (productId: string) => void;
  quoteExits?: QuoteExits[];
  teamProducts?: TeamInsuranceProduct[];
  isLoading?: boolean;
  bottomTableContent?: ReactNode;
  searchInput?: string;
}

export interface ProductItemProps {
  teamProduct: TeamInsuranceProduct;
  selectedTeamProducts: SelectedTeamProductsMap;
  quoteExits?: QuoteExits[];
  onProductSelected: (product: TeamInsuranceProduct) => void;
  onProductRemoved: (productId: string) => void;
  searchInput?: string;
}

export enum FilterType {
  CoverageLine = 'coverageLines',
  IsAdmitted = 'isAdmitted',
  IsPrimary = 'isPrimary',
}

export interface UseProductFilterAttributes extends SearchInputProps {
  sortedAndFilteredItems: TeamInsuranceProduct[];
  filters: Record<FilterType, ProductFilterAttributes>;
  clearFilters: () => void;
  isFilterApplied: boolean;
  coverageLineFilters: FilterElementProps[]; // Returning the new filters
  handleVisibleCoverageChange: (key: string) => void;
}
